export default "__VITE_ASSET__66d6ec0b__"